import React from "react";

import { BackButton, TitlePage } from "@atoms/index";
import * as Styled from "./styles";

interface IPageHeader {
  url: string;
  title: string;
  noClientSelection?: boolean;
}

const PageHeader: React.FC<IPageHeader> = ({ url, title, noClientSelection }) => (
  <Styled.PageHeader noClientSelection={noClientSelection}>
    <BackButton backUrl={url} />
    <TitlePage title={title} />
  </Styled.PageHeader>
);

PageHeader.defaultProps = {
  noClientSelection: false
};

export default PageHeader;
